import React, {useEffect, useMemo, useState} from 'react'
import { useHistory } from 'react-router-dom'
import { Button, Select, SelectOption, Input, Slider, Toast } from '@kaleyra/emmy'
import { useTranslation } from 'react-i18next'
import cn from 'classnames'
import ArrowUpIcon from '../../../assets/ArrowUpIcon.svg'
import ArrowDownIcon from '../../../assets/ArrowDownIcon.svg'
import AddIcon from '../../../assets/addV.png'
import ScheduleIcon from '../../../assets/ScheduleIcon.svg'
import BackIcon from '../../../assets/Back.svg'
import ErrorIcon from '../../../assets/error.png'
import LoaderGif from '../../../assets/loader.gif'

import * as urls from '../../../urls';
import { C2CModalInterface, C2CCallInterface } from '../../../store/models/C2CModal.interface'
import { BridgeNumberReducer } from '../../../store/models/voiceLogs.interface'
import ScheduleCall from '../containers/ScheduleCall'
import {checkSupportRole} from '../../../utils'
import Styles from '../index.module.scss'
import { isEmpty, debounce, find } from 'lodash'

export type MapStateToPropsType = {
    C2CModal: C2CModalInterface,
    C2CCall: C2CCallInterface,
    bridgeNumbers: BridgeNumberReducer,
    numberValidationInProgress: boolean,
    callbackData: any,
    callbackProfileSearchInProgress: boolean,
}

export type MapDispatchToPropsType = {
    getBridgeNumbers: () => void,
    closeC2CModal: () => void,
    clickToCall: (data: any,
        cbS: (a: string) => void,
        cbE: (a: string) => void) => void,
    validateNumber: (data: any, cb: (res: any) => void) => void,
    getCallbackProfiles: (filter: any, searchTer: string) => void,
    getSearchedData: (searchStr: any) => void,
}

const VoiceTemplate: React.FC<MapStateToPropsType & MapDispatchToPropsType> = ({
    C2CModal,
    C2CCall,
    bridgeNumbers,
    getBridgeNumbers,
    closeC2CModal,
    clickToCall,
    validateNumber,
    numberValidationInProgress,
    getCallbackProfiles,
    callbackData,
    getSearchedData,
    callbackProfileSearchInProgress
}) => {
    const { modalSource, initialSchema } = C2CModal
    const { callInitiated } = C2CCall
    const { bridgeNumbersData } = bridgeNumbers
    const { t } = useTranslation()
    const history = useHistory()

    const [change, setChange] = useState<any>({})
    const [customerNumber, setCustomerNumber] = useState<any>('')
    const [agentNumber, setAgentNumber] = useState<any>('')
    const [callerId, setCallerId] = useState<any>(undefined)
    const [callbackProfile, setCallbackProfile] = useState<any>(undefined)
    const [selectedCallbackProfile, setSelectedCallbackProfile] = useState<any>(null)
    const [retryNumber, setRetryNumber] = useState<string>('0')
    const [dialPreference, setDialPreference] = useState<string>('agent')
    const [scheduleOption, setScheduleOption] = useState<boolean>(false)
    const [scheduleModal, setScheduleModal] = useState<boolean>(false)

    const debouncedChange = React.useCallback(
        debounce((value:any = "") => onSearch(value), 400),
        []
    );

    const onSearch = (searchString: string) => {
        getSearchedData(searchString)
    };

    const retryNum = ['0', '1', '2']
    const dialPref = [
        {
            key: 'customer',
            value: 'Customer'
        },
        {
            key: 'agent',
            value: 'Agent'
        }
    ]

    useEffect(() => {

        getCallbackProfiles({}, 'title');

        if (isEmpty(bridgeNumbersData)) {
            getBridgeNumbers();
        }

        if (initialSchema && initialSchema.customerNumber) {
            setCustomerNumber(initialSchema.customerNumber)
            setChange((val: any) => {
                return {
                    ...val,
                    'customerNumValid': true,
                }
            })
        }
        if (initialSchema && initialSchema.agentNumber) {
            setAgentNumber(initialSchema.agentNumber)
            setChange((val: any) => {
                return {
                    ...val,
                    'agentNumValid': true,
                }
            })
        }

    }, [])

    useEffect(() => {
        if (!isEmpty(bridgeNumbersData)) {
            if (initialSchema && initialSchema.callerId) {
                setCallerId(initialSchema.callerId)
            }
        }
    }, [bridgeNumbersData])

    useEffect(() => {
        const status = checkButtonDisabled()
        if (status) setScheduleOption(false)
    }, [customerNumber, agentNumber])

    const enableMasking: (number|string) = initialSchema?.enableMasking;
    const disableInput = useMemo(()=>{
        return enableMasking === 1 || enableMasking === '1';
    },[enableMasking]);
    const showScheduleOption = (e: any) => {
        e.stopPropagation();
        setScheduleOption((option: boolean) => !option)
    }

    const checkButtonDisabled = () => {
        if (callInitiated || numberValidationInProgress) return true
        if (change['customerNumValid'] && change['agentNumValid'] && callerId) return false
        return true
    }


    const translateMessages = (msg: string) => {
        switch (msg) {
            case 'Invalid number':
                return t('validCountryMsg')
            case 'from and to cannot be same':
                return t('differentCustomerAgentNumMsg')
            case 'Submitted Successfully':
                return t('conCreatedmsg')
            case 'The agent, customer, and bridge number should be of the same country':
                return t('agentBridgeSameCountry')
            case 'Schedule time has to be 15 min greater from now':
                return t('scheduleTimeLaterError')
            default:
                return ''
        }
    }

    const handleSelectChange = (val: string) => {
        let requiredProfile = find(callbackData, { title: val })
        setSelectedCallbackProfile(requiredProfile)
        setCallbackProfile((requiredProfile||{}).title)
    }
    const handleClickToCall = () => {
        setScheduleOption(false)

        const data = {
            call_id: initialSchema?.callId,
            to: customerNumber,
            from: agentNumber,
            bridge: callerId,
            retry: retryNumber,
            dial_first: dialPreference,
            source: modalSource,
            ...(callbackProfile ? {
                // dlrurl: JSON.stringify([{ "callback_profile": [selectedCallbackProfile.profile_id] }])
                callback: JSON.stringify({call_end:{callback_profile:[selectedCallbackProfile.profile_id]}})
            } : {})
        }
        clickToCall(data,
            (msg: string) => {
                Toast(translateMessages(msg) || msg, 'success')
                closeC2CModal()
            },
            (errorMsg: string) => {
                Toast(translateMessages(errorMsg) || errorMsg, 'error')
            }
        )
    }

    const renderScheduleModal = () => {
        if (scheduleModal) {
            return (
                <Slider
                    visibility={scheduleModal}
                    containerId='root-modal'
                    containerClassName={Styles.sliderHeight}
                    title={
                        <span>
                            <img onClick={() => { setScheduleModal(false); setScheduleOption(false) }} src={BackIcon} alt='back'
                                style={{ marginRight: '1rem', cursor: 'pointer' }} />
                            <span>{t("scheduleCall")}</span>
                        </span>
                    }
                    onClose={() => setScheduleModal(false)}
                >
                    <ScheduleCall
                        closeModal={() => setScheduleModal(false)}
                        callData={{
                            agentNumber,
                            customerNumber,
                            callerId,
                            retryNumber,
                            modalSource,
                            dialPreference,
                            call_id: initialSchema?.callId,
                            callbackProfile: selectedCallbackProfile && selectedCallbackProfile.profile_id || null
                        }}
                        translateMessages={translateMessages}
                    />
                </Slider>
            )
        } else {
            return null
        }
    }

    return (
        <>
            <div className={Styles.voiceTemplate}>
                <Input
                    value={customerNumber}
                    label={t('customerNum')}
                    placeholder={t('customerNum')}
                    className={Styles.mrgBtm}
                    onChange={(e) => {
                        let value = e.target.value
                        let regex = /^\+?\d{0,14}$/
                        if (value && !regex.test(value)) return
                        setCustomerNumber(value)
                    }}
                    onBlur={() => {
                        validateNumber({
                            number: encodeURI(customerNumber)
                        }, (res) => {
                            if (res.data && res.data.is_valid === "1") {
                                setChange({
                                    ...change,
                                    'customerNumValid': true,
                                })
                            } else {
                                setChange({
                                    ...change,
                                    'customerNumValid': false,
                                })
                            }
                        })
                    }}
                    bottomLabelType={change.hasOwnProperty('customerNumValid') ? change['customerNumValid'] ? undefined : 'error' : undefined}
                    bottomLabel={change.hasOwnProperty('customerNumValid') ? change['customerNumValid'] ? undefined :
                        <span>
                            <img style={{ marginRight: '0.5rem' }} src={ErrorIcon} className={Styles.errorIcon} alt="error" />
                            {t('validCountryMsg')}
                        </span> : undefined
                    }
                    showBottomLabelSpace={false}
                    disabled={disableInput}
                />

                <Input
                    value={agentNumber}
                    label={t('agentNum')}
                    placeholder={t('agentNum')}
                    className={Styles.mrgBtm}
                    onChange={(e) => {
                        let value = e.target.value
                        let regex = /^\+?\d{0,14}$/
                        if (value && !regex.test(value)) return
                        setAgentNumber(value)
                    }}
                    onBlur={() => {
                        validateNumber({
                            number: encodeURI(agentNumber)
                        }, (res) => {
                            if (res.data && res.data.is_valid === "1") {
                                setChange({
                                    ...change,
                                    'agentNumValid': true,
                                })
                            } else {
                                setChange({
                                    ...change,
                                    'agentNumValid': false,
                                })
                            }
                        })
                    }}
                    bottomLabelType={change.hasOwnProperty('agentNumValid') ? change['agentNumValid'] ? undefined : 'error' : undefined}
                    bottomLabel={change.hasOwnProperty('agentNumValid') ? change['agentNumValid'] ? undefined :
                        <span>
                            <img style={{ marginRight: '0.5rem' }} src={ErrorIcon} className={Styles.errorIcon} alt="error" />
                            {t('validCountryMsg')}
                        </span> : undefined
                    }
                    showBottomLabelSpace={false}
                    disabled={disableInput}
                />

                <Select
                    showSearch={true}
                    value={callerId}
                    label={t('selCallerId')}
                    placeholder={t('selCallerId')}
                    className={Styles.mrgBtm}
                    onChange={(val: any) => setCallerId(val)}
                    showBottomLabelSpace={false}
                    allowClear
                >
                    {
                        !isEmpty(bridgeNumbersData) &&
                        Object.values(bridgeNumbersData).map((val) => <SelectOption key={val} value={val}>{val}</SelectOption>)
                    }
                </Select>

                <Select
                    showSearch={true}
                    onSearch={(value: string) => {
                        debouncedChange(value)
                    }}
                    value={callbackProfile}
                    className={Styles.mrgBtm}
                    label={t('Select Callback Profiles')}
                    placeholder={t('Select Callback Profiles')}
                    onChange={(val: any) => handleSelectChange(val)}
                    dropdownRender={(menu) => {
                        return (
                            <div>
                                <div className={Styles.addCallbackProfileOption} onClick={() => { closeC2CModal(); history.push(urls.CallbacksV2()) }}>
                                    <img className={Styles.mrgRSm} src={AddIcon} alt='add' />
                                    <span>{`Add new Callback Profile`}</span>
                                </div>
                                {menu}
                            </div>
                        )
                    }}
                    notFoundContent={
                        callbackProfileSearchInProgress ?
                            <div className={Styles.loadingContainer}>
                                <div><img src={LoaderGif} alt='loader' /></div>
                                <div>{`Loading...`}</div>
                            </div>
                            : null
                    }
                    showBottomLabelSpace={false}
                    allowClear
                >
                    {
                        !isEmpty(callbackData) &&
                        callbackData.map((val: any) => <SelectOption key={val.profile_id} value={val.title}>{val.title}</SelectOption>)
                    }
                </Select>

                <div className={Styles.flex}>
                    <div className={cn(Styles.halfWidth, Styles.mrgR)}>
                        <Select
                            value={retryNumber}
                            label={t(t('noOfRetry'))}
                            placeholder={t(t('noOfRetry'))}
                            className={Styles.mrgBtm}
                            onChange={(val: any) => setRetryNumber(val)}
                            showBottomLabelSpace={false}
                        >
                            {
                                retryNum.map((val) => <SelectOption key={val} value={val}>{val}</SelectOption>)
                            }
                        </Select>
                    </div>
                    <div className={Styles.halfWidth}>
                        <Select
                            value={dialPreference}
                            label={t('whomToDialFirst')}
                            placeholder={t('whomToDialFirst')}
                            className={Styles.mrgBtm}
                            onChange={(val: any) => setDialPreference(val)}
                            showBottomLabelSpace={false}
                        >
                            {
                                dialPref.map((item) => <SelectOption key={item.key} value={item.key}>{item.value}</SelectOption>)
                            }
                        </Select>
                    </div>

                </div>
            </div>


            <div className={Styles.footer}>
                {
                    scheduleOption &&
                    <span className={Styles.scheduleOption} onClick={() => { setScheduleModal(true); setScheduleOption(false) }}>
                        <img src={ScheduleIcon} alt="schedule"/>
                        <span className={Styles.scheduleText}>{t('schedule')}</span>
                    </span>
                }
                <span className={Styles.cancelBtn} onClick={() => closeC2CModal()}><Button type='tertiary'>{t('mainCancel')}</Button></span>
                {
                    !checkSupportRole() && 
                <span>
                    <Button icon={<img src={scheduleOption ? ArrowUpIcon : ArrowDownIcon}
                        onClick={checkButtonDisabled() ? undefined : showScheduleOption} 
                        alt="schedule"
                        />}
                        disabled={checkButtonDisabled()}
                        iconPosition='right'
                        onClick={() => handleClickToCall()} type='primary'>
                        {t('start')} </Button>
                </span>
                }
            </div>
            {renderScheduleModal()}
        </>
    )
}

export default VoiceTemplate
